import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { DeviceSettingsState } from './types';

const initialState: DeviceSettingsState = {
	/** ID выбранного аудио устройства ввода */
	selectedAudioInput: '',
	/** ID выбранного видео устройства */
	selectedVideoInput: '',
	/** ID выбранного аудио устройства вывода */
	selectedAudioOutput: '',
	/** Громкость микрофона */
	micVolume: 1,
	/** Громкость динамика */
	spkVolume: 1,
};

const deviceSettingsSlice = createSlice({
	name: 'deviceSettings',
	initialState,
	reducers: {
		setSelectedAudioInput(state, action: PayloadAction<string>) {
			state.selectedAudioInput = action.payload;
		},
		setSelectedVideoInput(state, action: PayloadAction<string>) {
			state.selectedVideoInput = action.payload;
		},
		setSelectedAudioOutput(state, action: PayloadAction<string>) {
			state.selectedAudioOutput = action.payload;
		},
		setMicVolume(state, action: PayloadAction<number>) {
			state.micVolume = action.payload;
		},
		setSpkVolume(state, action: PayloadAction<number>) {
			state.spkVolume = action.payload;
		},
		// Optional: reset to defaults
		resetDeviceSettings(state) {
			Object.assign(state, initialState);
		},
	},
});

export const {
	setSelectedAudioInput,
	setSelectedVideoInput,
	setSelectedAudioOutput,
	setMicVolume,
	setSpkVolume,
	resetDeviceSettings,
} = deviceSettingsSlice.actions;

export const deviceSettingsReducer = deviceSettingsSlice.reducer;
